import { sortBy } from "lodash";
import React, { useEffect, useState } from "react";
import { ServerActions } from "../actions/serverActions";
import { getQryValue } from "../util/helper";

import moment from "moment";
import "../css/reqHistory.css";

const RequestHistory = () => {
  const reqId = getQryValue("requestId");
  const [reqData, setReqData] = useState([]);
  const [error, setError] = useState(false);
  const [collapse, setCollapse] = useState({});
  const [exCollapse, setExCollapse] = useState({});

  useEffect(() => {
    if (reqId) {
      setError(false);
      ServerActions.getRequestHistory(reqId)
        .done((res) => setReqData(res))
        .fail(() => setError(true));
    }
  }, [reqId]);

  useEffect(() => {
    $("#requestHistory").parent().css("margin-top", "52px").css("overflow", "auto");
    document.title = `GR-${reqData[0]?.syncId}-History Detail`;
  }, [reqData]);

  if (error) {
    return <div>Failed to load request history</div>;
  }

  if (!reqData?.length) {
    return <div>The requested item has no history associated</div>;
  }

  return (
    <div id="requestHistory">
      <div className="req-title"><b>History Detail</b></div>
      {reqData.map((req, index) => {
        const prevReq = index >= reqData.length - 1 ? req : reqData[index + 1];
        const res = req?.restrictionDetail || {};
        const prevRes = prevReq?.restrictionDetail || {};

        const {
          formBDetail,
          formADetail,
          formCDetail,
          tcmDetail,
          shortFlag,
          comments,
          restrictionSubdivisionList,
        } = res;

        const {
          formBDetail: prevFormB,
          formADetail: prevFormA,
          formCDetail: prevFormC,
          tcmDetail: prevTcm,
          shortFlag: prevShortFlag,
          restrictionSubdivisionList: prevSubs,
          comments: prevComments,
        } = prevRes;

        const getForm = (type, prev) => {
          if (type === "A") {
            return (prev && prevFormA) || formADetail;
          } else if (type === "B") {
            return (prev && prevFormB) || formBDetail;
          } else if (type === "C") {
            return (prev && prevFormC) || formCDetail;
          } else if (type === "TCM") {
            return (prev && prevTcm) || tcmDetail;
          }
        };

        const prevBorderingFlags = !prevRes.borderingFlags
          ? []
          : sortBy(prevRes.borderingFlags, "id");
        const borderingFlags = !res.borderingFlags
          ? []
          : sortBy(res.borderingFlags, "id");

        const dispatchers = !req.dispatchers
          ? []
          : sortBy(req.dispatchers, "dispatcherId");
        const prevDispatchers = !prevReq.dispatchers
          ? []
          : sortBy(prevReq.dispatchers, "dispatcherId");

        //        const subList = !subdivisions
        //          ? []
        //          : map(sortBy(subdivisions, "sequenceNumber"), "subdivisionName");
        //        const prevSubList = !prevSubs
        //          ? []
        //          : map(sortBy(prevSubs, "sequenceNumber"), "subdivisionName");

        let subListFinal = !restrictionSubdivisionList
          ? []
          : restrictionSubdivisionList.map(function (sub) { return sub.subdivisionName });

        let subsList = subListFinal.join(",");
        let prevsubListFinal = !prevSubs
          ? []
          : prevSubs.map(function (sub) { return sub.subdivisionName });
        let prevSubsList = prevsubListFinal.join(",");

        let diffSubs = true;
        if (subsList !== prevSubsList) {
          diffSubs = false;
        }
        const guids = res?.trackGuids?.filter((g) => !g.isExcluded) || [];
        const prevGuids =
          prevRes?.trackGuids?.filter((g) => !g.isExcluded) || [];
        const hideGuids = guids.some((g) =>
          prevGuids.some((p) => p.dbVersion !== g.dbVersion)
        );

        const exGuids = res?.trackGuids?.filter((g) => !!g.isExcluded) || [];
        const prevExGuids =
          prevRes?.trackGuids?.filter((g) => !!g.isExcluded) || [];
        const hideExGuids = exGuids.some((g) =>
          prevExGuids.some((p) => p.dbVersion !== g.dbVersion)
        );
        return (
          <table
            align="center"
            border="0"
            style={{ width: "80%", borderSpacing: 0, borderBottom: "1px dashed" }}
          >
            <tbody>
              <tr className="text-left">
                <td style={{ paddingRight: 0 }} />
              </tr>

              <tr className="text-left">
                <td>
                  <b>Restriction Id: </b>
                  <font
                    className={
                      res?.controlNumber !== prevRes?.controlNumber && "red"
                    }
                  >
                    {res?.controlNumber}
                  </font>
                </td>
                <td colSpan="3">
                  <b>GRIT Id: </b> GR{req?.syncId}
                </td>
                <td>
                  <b>Form Type: </b> {res?.type}
                </td>
                <td>
                  <b>Subdivision: </b> {res?.subdivision}
                </td>
                {req?.status === "request" ? (
                  <td colSpan="3">
                    <b>Status:</b>
                    {req?.pendingAction === "O" ? (
                      <font className="red">Transferred Request</font>
                    ) : (
                      <font
                        className={
                          req?.pendingAction !== prevReq.pendingAction && "red"
                        }
                      >
                        Request
                      </font>
                    )}
                  </td>
                ) : (
                  <td colSpan="3">
                    <b>Status:</b>
                    <font className={req.status !== prevReq.status && "red"}>
                      {String(req?.status).toLocaleUpperCase()}
                    </font>
                  </td>
                )}
                {/* {res?.type === "A" && (
                  <td>
                    <b>Requested AS:</b>
                    <font
                      className={
                        formADetail?.appliesToLimitedNumberOfTrains !==
                        prevFormA?.appliesToLimitedNumberOfTrains &&
                        formADetail?.outForExtendedTime !==
                        prevFormA.outForExtendedTime &&
                        "red"
                      }
                    >
                      {formADetail?.outForExtendedTime
                        ? "OVERNIGHT"
                        : "TEMPORARY"}
                    </font>
                  </td>
                )} */}
              </tr>
              <tr height="20px"></tr>
              {req?.override && (
                <>
                  <tr className="text-left">
                    <th>Override:</th>
                    <th colSpan="3">Grantor:</th>
                    <th colSpan="4">Granted Time/Date:</th>
                  </tr>
                  <tr className="text-left">
                    <td>Yes</td>
                    <td colSpan="3">{req?.override?.userId} </td>
                    <td colSpan="4">{req?.override?.createTimeStamp} </td>
                  </tr>
                  <tr height="20px"></tr>
                </>
              )}
              {req?.restrictionDetail?.subdivision === "MULTI" && (
                <>
                  <tr className="text-left">
                    <th>Subdivisions:</th>
                  </tr>
                  <tr>
                    <td colSpan="4">
                      <table style={{ position: "static" }} className="black">
                        <tr>
                          <td className={diffSubs == false && "red"}>
                            {subsList}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr height="20px"></tr>
                </>
              )}
              {formatTableHeader(res?.type, getForm(res?.type))}
              {formatTableData(
                res?.type,
                getForm(res?.type),
                getForm(res?.type, true),
                res,
                prevRes,
                req,
                prevReq
              )}
              <tr height="20px" />
              {formatShortFlag(
                res?.type,
                getForm(res?.type),
                getForm(res?.type, true),
                res,
                req,
                prevReq,
                shortFlag,
                prevShortFlag
              )}
              <tr height="20px" />
              {res?.type === "B" && (
                <>
                  <tr className="text-left">
                    <th colSpan="2">Reason Code:</th>
                    <th>Impede Traffic:</th>
                    <th colSpan="2">12 Hr Supervisor Approval:</th>
                    <th>Auth Init:</th>
                    <th colSpan="2">Issued Time/Date:</th>
                  </tr>
                  <tr className="text-left">
                    <td
                      colSpan="2"
                      className={
                        formBDetail?.reasonCode?.reasonDescription !==
                        prevFormB?.reasonCode?.reasonDescription && "red"
                      }
                    >
                      {formBDetail?.reasonCode?.reasonDescription}
                    </td>
                    <td
                      className={
                        formBDetail.impedesTraffic !==
                        prevFormB.impedesTraffic && "red"
                      }
                    >
                      {formBDetail?.impedesTraffic}
                    </td>
                    <td colSpan="2">{req?.supervisorName}</td>
                    <td>{res?.authInitials}</td>
                    <td colSpan="2">
                      {getDtTime(res?.effectiveTimeStamp)}
                      {isValidDt(res?.effectiveTimeStamp) &&
                        formBDetail?.timezone}
                    </td>
                  </tr>
                </>
              )}
              <tr height="10px" />
              {formatBorderHeader(
                res?.type,
                req?.status,
                dispatchers,
                prevDispatchers,
                borderingFlags,
                prevBorderingFlags
              )}
              {formatBorderData(
                res?.type,
                req,
                prevReq,
                getForm(res?.type),
                getForm(res?.type, true),
                dispatchers,
                prevDispatchers,
                borderingFlags,
                prevBorderingFlags
              )}
              <tr height="20px" />
              {formatComments(res?.type, req, prevReq, comments, prevComments)}
              <tr height="20px" />
              {formatGuids(
                collapse[index],
                () =>
                  setCollapse((pre) => ({
                    ...pre,
                    [index]: !collapse[index],
                  })),
                guids,
                guids?.length !== prevGuids?.length,
                hideGuids
              )}
              <tr height="20px" />
              {formatGuids(
                exCollapse[index],
                () =>
                  setExCollapse((pre) => ({
                    ...pre,
                    [index]: !exCollapse[index],
                  })),
                exGuids,
                exGuids?.length !== prevExGuids?.length,
                hideExGuids,
                true
              )}
              <tr height="10px" />
            </tbody>
          </table>
        );
      })}
    </div>
  );
};

const formatTableHeader = (type, form) => {
  if (type === "A") {
    return (
      <tr className="text-left">
        <th>From MP:</th>
        <th>To MP:</th>
        <th colSpan="2">Passenger Speed:</th>
        <th>Freight Speed:</th>
        <th>Authorized By:</th>
        <th>Phone Number:</th>
        <th>Reason Code:</th>
      </tr>
    );
  } else if (type === "B") {
    return (
      <tr className="text-left">
        <th>From MP:</th>
        <th>To MP:</th>
        <th colSpan="2">From Time:</th>
        <th>From Date:</th>
        <th colSpan="2" className="text-left">
          To Time:
        </th>
        <th>To Date:</th>
      </tr>
    );
  } else if (type === "C" || type === "TCM") {
    return (
      <tr className="text-left">
        {form.fromLocation ? (
          <>
            <th>From Location:</th>
            <th>To Location:</th>
          </>
        ) : (
          <>
            <th>From MP:</th>
            <th>To MP:</th>
          </>
        )}
        <th>Authorized By:</th>
      </tr>
    );
  }
  return <></>;
};

const formatTableData = (
  type,
  form = {},
  prevForm = {},
  res = {},
  prevRes = {},
  req = {},
  prevReq = {}
) => {
  if (type === "A") {
    return (
      <tr className="text-left">
        <td
          className={
            (res.workStartMp !== prevRes.workStartMp ||
              res.workStartMpSuffix !== prevRes.workStartMpSuffix) &&
            "red"
          }
        >
          {res.workStartMp?.toString()?.indexOf(".") === -1
            ? res.workStartMp + ".0" + (res.workStartMpSuffix || "")
            : res.workStartMp + "" + (res.workStartMpSuffix || "")}
        </td>
        <td
          className={
            (res.workEndMp !== prevRes.workEndMp ||
              res.workEndMpSuffix !== prevRes.workEndMpSuffix) &&
            "red"
          }
        >
          {res.workEndMp?.toString()?.indexOf(".") === -1
            ? res.workEndMp + ".0" + (res.workEndMpSuffix || "")
            : res.workEndMp + "" + (res.workEndMpSuffix || "")}
        </td>
        <td
          className={form.passengerSpeed !== prevForm.passengerSpeed && "red"}
        >
          {form?.passengerSpeed === -1 ? "NA" : form?.passengerSpeed}
        </td>
        <td
          colSpan="2"
          className={form.freightSpeed !== prevForm.freightSpeed && "red"}
        >
          {form?.freightSpeed === -1 ? "NA" : form?.freightSpeed}
        </td>
        <td className={form.authorizedBy !== prevForm.authorizedBy && "red"}>
          {form?.authorizedBy}
        </td>
        <td className={req.phoneNumber !== prevReq.phoneNumber && "red"}>
          {req?.phoneNumber}
        </td>
        <td
          className={
            form?.reasonCode?.reasonDescription !==
            prevForm?.reasonCode?.reasonDescription && "red"
          }
        >
          {form?.reasonCode?.reasonDescription?.trim()}
        </td>
      </tr>
    );
  } else if (type === "B") {
    return (
      <tr className="text-left">
        <td
          className={
            (res.workStartMp !== prevRes.workStartMp ||
              res.workStartMpSuffix !== prevRes.workStartMpSuffix) &&
            "red"
          }
        >
          {res.workStartMp?.toString()?.indexOf(".") === -1
            ? res.workStartMp + ".0" + (res.workStartMpSuffix || "")
            : res.workStartMp + "" + (res.workStartMpSuffix || "")}
        </td>
        <td
          className={
            (res.workEndMp !== prevRes.workEndMp ||
              res.workEndMpSuffix !== prevRes.workEndMpSuffix) &&
            "red"
          }
        >
          {res.workEndMp?.toString()?.indexOf(".") === -1
            ? res.workEndMp + ".0" + (res.workEndMpSuffix || "")
            : res.workEndMp + "" + (res.workEndMpSuffix || "")}
        </td>
        <td
          colSpan="2"
          className={
            getTime(form?.workStartDate) !== getTime(prevForm.workStartDate) &&
            "red"
          }
        >
          {isValidDt(form?.workStartDate) &&
            getTime(form?.workStartDate) + form?.timezone}
        </td>
        <td
          className={
            getDate(form?.workStartDate) !== getDate(prevForm.workStartDate) &&
            "red"
          }
        >
          {getDate(form?.workStartDate)}
        </td>
        <td
          colSpan="2"
          className={
            getTime(form?.workEndDate) !== getTime(prevForm.workEndDate) &&
            "red"
          }
        >
          {isValidDt(form?.workEndDate) &&
            getTime(form?.workEndDate) + form?.timezone}
        </td>
        <td
          className={
            getDate(form?.workEndDate) !== getDate(prevForm.workEndDate) &&
            "red"
          }
        >
          {getDate(form?.workEndDate)}
        </td>
      </tr>
    );
  } else if (type === "C" || type === "TCM") {
    return (
      <tr className="text-left">
        {form.fromLocation ? (
          <>
            <td
              className={form.fromLocation !== prevForm.fromLocation && "red"}
            >
              {form?.fromLocation}
            </td>
            <td className={form.toLocation !== prevForm.toLocation && "red"}>
              {form?.toLocation}
            </td>
          </>
        ) : req?.restrictionDetail?.subdivision === "MULTI" ? (
          <>
            <td className="black">N/A</td>
            <td className="black">N/A</td>
          </>
        ) : (
          <>
            <td
              className={
                (res?.workStartMp !== prevRes?.workStartMp ||
                  res?.workStartMpSuffix !== prevRes?.workStartMpSuffix) &&
                "red"
              }
            >
              {res?.workStartMp?.toString()?.indexOf(".") === -1
                ? res?.workStartMp + ".0" + (res?.workStartMpSuffix || "")
                : res?.workStartMp + "" + (res?.workStartMpSuffix || "")}
            </td>
            <td
              className={
                (res?.workEndMp !== prevRes?.workEndMp ||
                  res?.workEndMpSuffix !== prevRes?.workEndMpSuffix) &&
                "red"
              }
            >
              {res?.workEndMp?.toString()?.indexOf(".") === -1
                ? res?.workEndMp + ".0" + (res?.workEndMpSuffix || "")
                : res?.workEndMp + "" + (res?.workEndMpSuffix || "")}
            </td>
          </>
        )}
        <td className={form?.authorizedBy !== prevForm?.authorizedBy && "red"}>
          {form?.authorizedBy}
        </td>
      </tr>
    );
  }
  return <></>;
};

const formatShortFlag = (
  type,
  form = {},
  prevForm = {},
  res = {},
  req = {},
  prevReq = {},
  shortFlag = {},
  prevShortFlag = {}
) => {
  if (type === "A") {
    let flagOnePresent = false
    if (shortFlag?.flagOneMp !== prevShortFlag?.flagOneMp) {
      flagOnePresent = true
    }

    let flagTwoPresent = false
    if (shortFlag?.flagTwoMp !== prevShortFlag?.flagTwoMp) {
      flagTwoPresent = true
    }
    return (
      <>
        <tr className="text-left">
          <th>Short Flag:</th>
          <th>Short Flag:</th>
          <th colSpan="2">No Flags:</th>
          <th>Estimated removal of Slow Order:</th>
          <th colSpan="2">Effective Date/Time:</th>
          <th>Issued Time/Date:</th>
        </tr>
        <tr className="text-left">
          <td
            className={
              flagOnePresent && "red"
            }
          >
            {Number.isFinite(shortFlag?.flagOneMp) ?
              Number(shortFlag?.flagOneMp).toFixed(1).toString()
              + (shortFlag?.flagOneMpSuffix || "")
              : ""}
          </td>
          <td
            className={
              flagTwoPresent && "red"
            }
          >
            {Number.isFinite(shortFlag?.flagTwoMp) ?
              Number(shortFlag?.flagTwoMp).toFixed(1).toString()
              + (shortFlag?.flagTwoMpSuffix || "")
              : ""}
          </td>
          <td
            className={
              shortFlag?.restrictionFlagsNotDisplayed !==
              prevShortFlag?.restrictionFlagsNotDisplayed && "red"
            }
            colSpan="2"
          >
            {shortFlag?.restrictionFlagsNotDisplayed === "Y" ? "Y" : ""}
          </td>
          <td>
            <table style={{ position: "static" }}>
              <tr>
                <td
                  className={
                    form?.expectedExpireTime !== prevForm?.expectedExpireTime &&
                    "red"
                  }
                >
                  {getDate(form?.expectedExpireTime)}
                </td>
              </tr>
              {form.sloDtChangeReason && (
                <tr>
                  <td className="red">Comments: {form?.sloDtChangeReason}</td>
                </tr>
              )}
            </table>
          </td>
          <td
            colSpan="2"
            className={form?.effectiveTime !== prevForm?.effectiveTime && "red"}
          >
            {getDtTime(form?.effectiveTime)}
            {isValidDt(form?.effectiveTime) && form?.effectiveTimezone}
          </td>
          <td>
            {getDtTime(res?.effectiveTimeStamp)}
            {isValidDt(res?.effectiveTimeStamp) && form?.effectiveTimezone}
          </td>
        </tr>
      </>
    );
  }
  if (type === "B") {
    return (
      <>
        <tr className="text-left">
          <th>Short Flag:</th>
          <th>Short Flag:</th>
          <th colSpan="2">Foreman:</th>
          <th>Gang:</th>
          <th colSpan="2">Phone Number:</th>
          <th>Radio Channel:</th>
        </tr>
        <tr className="text-left">
          <td
            className={
              shortFlag?.flagOneMp !== prevShortFlag?.flagOneMp && "red"
            }
          >
            {Number.isFinite(shortFlag?.flagOneMp) ?
              Number(shortFlag?.flagOneMp).toFixed(1).toString()
              + (shortFlag?.flagOneMpSuffix || "")
              : ""}
          </td>
          <td
            className={
              shortFlag?.flagTwoMp !== prevShortFlag?.flagTwoMp && "red"
            }
          >
            {Number.isFinite(shortFlag?.flagTwoMp) ?
              Number(shortFlag?.flagTwoMp).toFixed(1).toString()
              + (shortFlag?.flagTwoMpSuffix || "")
              : ""}
          </td>
          <td
            colSpan="2"
            className={
              form?.foremanName?.trim() !== prevForm?.foremanName?.trim() &&
              "red"
            }
          >
            {form?.foremanName}
          </td>
          <td className={form.gang !== prevForm.gang && "red"}>{form?.gang}</td>
          <td
            colSpan="2"
            className={prevReq.phoneNumber !== req.phoneNumber && "red"}
          >
            {req?.phoneNumber}
          </td>
          <td className={form.radioChannel !== prevForm.radioChannel && "red"}>
            {form?.radioChannel}
          </td>
        </tr>
      </>
    );
  }
  return <></>;
};

const formatBorderHeader = (
  type,
  status,
  dispatchers = [],
  prevDispatchers = [],
  borderingFlags = [],
  prevBorderingFlags = []
) => {
  if (["A", "B"].includes(type)) {
    return (
      <tr className="text-left">
        <th style={{ position: "static" }} colSpan="2">
          Tracks:
        </th>
        <th
          className={
            borderingFlags?.length !== prevBorderingFlags?.length && "red"
          }
          style={{ position: "static" }}
        >
          Bordering Flags:
        </th>
        <th style={{ position: "static" }} colSpan="2">
          Created By/Date:
        </th>
        <th style={{ position: "static" }}>Modified By/Date:</th>
        <th
          className={
            status !== "voided" ||
            (dispatchers?.length !== prevDispatchers?.length && "red")
          }
          style={{ position: "static" }}
          colSpan="2"
        >
          DS Owners:
        </th>
      </tr>
    );
  } else if (type === "C") {
    return (
      <tr className="text-left">
        <th style={{ position: "static" }} colSpan="2">
          Estimated Removal Date:
        </th>
        <th style={{ position: "static" }} colSpan="2">
          Created By/Date:
        </th>
        <th style={{ position: "static" }}>Modified By/Date:</th>
      </tr>
    );
  } else if (type === "TCM") {
    return (
      <tr className="text-left">
        <th style={{ position: "static" }} colSpan="2">
          Estimated Removal Date:
        </th>
        <th style={{ position: "static" }} colSpan="2">
          Created By/Date:
        </th>
        <th style={{ position: "static" }}>Modified By/Date:</th>
        <th style={{ position: "static" }}>Print Desk Copy:</th>
        <th style={{ position: "static" }}>Condition Permanent:</th>
      </tr>
    );
  }
};

const formatBorderData = (
  type,
  req,
  prevReq,
  form,
  prevForm,
  dispatchers = [],
  prevDispatchers = [],
  borderingFlags = [],
  prevBorderingFlags = []
) => {
  if (["A", "B"].includes(type)) {
    return (
      <tr>
        <td colSpan="2">
          <table
            style={{ position: "static" }}
            className={
              req?.restrictionDetail?.tracks?.length !==
              prevReq?.restrictionDetail?.tracks?.length && "red"
            }
          >
            {req?.restrictionDetail?.tracks?.map((track) => (
              <tr className="text-left">
                <td>{track.name}</td>
              </tr>
            ))}
          </table>
        </td>
        <td>
          <table style={{ position: "static" }}>
            {borderingFlags?.length ? (
              borderingFlags?.map((flag, i) => (
                <tr
                  className={flag?.subdivision?.indexOf("-H") !== -1 && "red"}
                >
                  <td
                    className={
                      (flag?.mp !== prevBorderingFlags[i]?.mp ||
                        flag?.mpSuffix !== prevBorderingFlags[i]?.mpSuffix) &&
                      "red"
                    }
                  >
                    {flag?.subdivision?.split("-")[0]}{" "}
                    {flag?.mp.toString().indexOf(".") === -1
                      ? flag?.mp + ".0" + (flag.mpSuffix || "") : flag?.mp + (flag.mpSuffix || "")}
                  </td>
                </tr>
              ))
            ) : (
              <tr
                className={
                  borderingFlags?.length !== prevBorderingFlags?.length && "red"
                }
              >
                <td
                  width="70px"
                  height="20px"
                  className={
                    borderingFlags?.length !== prevBorderingFlags?.length &&
                    "red"
                  }
                ></td>
              </tr>
            )}
          </table>
        </td>
        <td colSpan="2">
          <table style={{ position: "static" }}>
            <tr>
              <td>{req?.createUser}</td>
            </tr>
            <tr>
              <td>
                {req?.createTimeStamp && getDtTime(req?.createTimeStamp)} C
              </td>
            </tr>
          </table>
        </td>
        <td>
          <table style={{ position: "static" }}>
            <tr>
              <td>{req?.lastModifiedUser}</td>
            </tr>
            <tr>
              <td>{getDtTime(req?.lastModifiedTimeStamp)} C</td>
            </tr>
          </table>
        </td>
        <td colSpan="2">
          <table style={{ position: "static" }}>
            {dispatchers?.length !== 0 ?
              dispatchers?.map((disp, i) => (
                <tr>
                  <td
                    className={
                      (dispatchers.length !== prevDispatchers?.length ||
                        disp.dispatcherId !== prevDispatchers[i].dispatcherId ||
                        disp.statusCode !== prevDispatchers[i].statusCode) &&
                      "red"
                    }
                  >
                    {disp?.statusCode} {disp?.dispatcherId?.toString()}
                  </td>
                </tr>
              )) : ""}
          </table>
        </td>
      </tr>
    );
  } else if (type === "C") {
    return (
      <tr>
        <td colSpan="2">
          <table style={{ position: "static" }}>
            <tr>
              <td
                className={
                  form?.estimatedRemovalDate !==
                  prevForm?.estimatedRemovalDate && "red"
                }
              >
                {getDate(form?.estimatedRemovalDate)}
              </td>
            </tr>
            {form?.restrictionUpdateComments && (
              <tr>
                <td className="red">
                  Comments: {form?.restrictionUpdateComments}
                </td>
              </tr>
            )}
          </table>
        </td>
        <td colSpan="2">
          <table style={{ position: "static" }}>
            <tr>
              <td>{req?.createUser}</td>
            </tr>
            <tr>
              <td>
                {req?.createTimeStamp && getDtTime(req?.createTimeStamp)} C
              </td>
            </tr>
          </table>
        </td>
        <td>
          <table style={{ position: "static" }}>
            <tr>
              <td>{req?.lastModifiedUser}</td>
            </tr>
            <tr>
              <td>{getDtTime(req?.lastModifiedTimeStamp)} C</td>
            </tr>
          </table>
        </td>
      </tr>
    );
  } else if (type === "TCM") {
    return (
      <tr>
        <td colSpan="2">
          <table style={{ position: "static" }}>
            <tr>
              <td
                className={
                  form?.estimatedRemovalDate !==
                  prevForm?.estimatedRemovalDate && "red"
                }
              >
                {getDtTime(form?.estimatedRemovalDate)}
              </td>
            </tr>
            {form?.restrictionUpdateComments && (
              <tr>
                <td className="red">
                  Comments: {form?.restrictionUpdateComments}
                </td>
              </tr>
            )}
          </table>
        </td>
        <td colSpan="2">
          <table style={{ position: "static" }}>
            <tr>
              <td>{req?.createUser}</td>
            </tr>
            <tr>
              <td>
                {req?.createTimeStamp && getDtTime(req?.createTimeStamp)} C
              </td>
            </tr>
          </table>
        </td>
        <td>
          <table style={{ position: "static" }}>
            <tr>
              <td>{req?.lastModifiedUser}</td>
            </tr>
            <tr>
              <td>{getDtTime(req?.lastModifiedTimeStamp)} C</td>
            </tr>
          </table>
        </td>
        <td>
          <table style={{ position: "static" }}>
            <tr>
              <td
                className={
                  form?.printIndicator !== prevForm?.printIndicator && "red"
                }
              >
                {form?.printIndicator}
              </td>
            </tr>
          </table>
        </td>
        <td>
          <table style={{ position: "static" }}>
            <tr>
              <td
                className={
                  form?.permanentIndicator !== prevForm?.permanentIndicator &&
                  "red"
                }
              >
                {form?.permanentIndicator}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    );
  }
};

const formatComments = (
  type,
  req = {},
  prevReq = {},
  comments = [],
  prevComments = []
) => {
  if (["A", "B"].includes(type)) {
    return (
      <>
        <tr className="text-left">
          <th className={comments?.length !== prevComments?.length && "red"}>
            Comments:
          </th>
          <td colSpan="5"></td>
          {req?.status === "rejected" && <th>Reject Reason:</th>}
        </tr>
        <tr>
          <td colSpan="6">
            {comments?.map((c) => (
              <tr>
                <td colSpan="6">{c.comment}</td>
              </tr>
            ))}
          </td>
          {req.status === "rejected" && (
            <td
              className={
                req?.rejectionReason !== prevReq?.rejectionReason && "red"
              }
            >
              {req?.rejectionReason}
            </td>
          )}
        </tr>
      </>
    );
  } else if (type === "C" || type === "TCM") {
    let text = comments?.map(function (line) {
      return line.comment;
    });
    let commentsText = text.join("\n");

    let prevText = prevComments?.map(function (line) {
      return line.comment;
    });
    let prevcommentsText = prevText.join("\n");

    let diffComments = true;
    if (commentsText !== prevcommentsText) {
      diffComments = false;
    }

    return (
      <>
        <tr className="text-left">
          <th className={diffComments === false && "red"}>
            Text:
          </th>
        </tr>
        <tr>
          <td colSpan="12">
            <textarea
              name="cmnts"
              rows="20"
              cols="150"
              style={{
                overflow: "auto",
                border: "2px solid black",
                textAlign: "left",
              }}
              disabled
              value={commentsText}
            >
            </textarea>
          </td>
        </tr>
      </>
    );
  }
};

const formatGuids = (collapse, setCollapse, guids, changed, hide, excluded) => {
  if (!guids?.length) {
    return <></>;
  }
  return (
    <tr className="text-left">
      <td colSpan="4">
        <table>
          <tr>
            <td
              style={{ cursor: "pointer" }}
              onClick={setCollapse}
              colSpan={5}
              className={changed && "red"}
            >
              <b>
                **{excluded ? "Excluded " : ""}Track Guids ({guids?.length})**
              </b>
            </td>
          </tr>
          {!!collapse && (
            <>
              <tr className="text-left guid}">
                <th style={{ width: "100px" }}>Guid Number </th>
                <th style={{ width: "150px" }}>Track Name </th>
                <th style={{ width: "100px" }}>Start MP </th>
                <th style={{ width: "100px" }}>End MP </th>
                <th style={{ width: "100px" }}>Tmds Db Vrsn </th>
                <th style={{ width: "100px" }}>Ptc Db Vrsn </th>
              </tr>
              {guids?.map((guid) => (
                <tr className="text-left guid">
                  <td>{guid.guidNumber}</td>
                  <td>{guid.trackName}</td>
                  <td>{guid.startMp + "" + (guid?.mpSuffix || "")}</td>
                  <td>{guid.endMp + "" + (guid.mpSuffix || "")}</td>
                  <td>{guid.dbVersion}</td>
                  <td>{guid.ptcVersion}</td>
                </tr>
              ))}
            </>
          )}
        </table>
      </td>
    </tr>
  );
};

const isValidDt = (dt) => moment(dt).isValid();

const getTime = (dt) => (isValidDt(dt) ? moment(dt).format("HH:mm") : "");
const getDate = (dt) => (isValidDt(dt) ? moment(dt).format("YYYY-MM-DD") : "");
const getDtTime = (dt) =>
  isValidDt(dt) ? moment(dt).format("YYYY-MM-DD HH:mm:ss") : "";

export default RequestHistory;
